import React from "react";
import {Modal, useTheme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import clsx from "clsx";

const useStyle = makeStyles(theme => {
    return {
        root: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            overflowY:"auto",
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(2),
            position: "absolute"
        }
    }
})

export default function({open, children, className, ...props}){
    const styles = useStyle(useTheme())
    return <Modal open={open}>
        <div className={clsx(styles.root, className)} {...props}>
            {children}
        </div>
    </Modal>
}
